import { createSelector } from 'reselect';

export const documentsSelector = (state) => state.documents;

export const selectRequiredDocuments = createSelector(
  documentsSelector,
  (state) => state.RequiredDocuments,
);
